export const getNameAndExtension = (val: string) => {
  const nameArr = val.trim().split(".");
  const extension = nameArr.length > 1 ? nameArr.pop() : undefined;
  const name = nameArr.join(".");
  return { name, extension };
};
